import { MegaMenuSmallBlock } from "components/molecules/MegaMenuSmallBlock";
import { shrinkNav } from "components/templates/Breakpoints";
import { useLocale } from "hooks";
import { Link } from "@components/atoms";
import { FC } from "react";
import styled from "styled-components";
import { Container, ResizableContainer } from "./styles";
import { useTranslations } from "next-intl";
import { config } from "@utils";

export const MegaMenuLogIn: FC = () => {
  const { locale } = useLocale();
  const upperCaseLocale = locale === "za" ? "SA" : locale === "jp" ? "JP" : locale.toUpperCase();
  const t = useTranslations("shared/mega-menu");

  return (
    <ResizableContainer>
      <StyledContainer>
        <Column>
          <Link href={`${config.TEAM_URL}/login?region=${upperCaseLocale}`}>
            <MegaMenuSmallBlock
              title={t<string>("login.first.title")}
              desc={t<string>("login.first.desc")}
              width="24rem"
            />
          </Link>
          <Link href={`${config.MEMBERS_URL}/?region=${upperCaseLocale}`}>
            <MegaMenuSmallBlock
              title={t<string>("login.second.title")}
              desc={t<string>("login.second.desc")}
              width="24rem"
            />
          </Link>
        </Column>
      </StyledContainer>
    </ResizableContainer>
  );
};

const StyledContainer = styled(Container)`
  width: 26rem;
  flex-direction: column;
  position: absolute;
  right: 2.5rem;

  ${shrinkNav} {
    right: -6rem;
  }
`;

const Column = styled.div`
  padding: 1rem;
`;
